import { GraviGrid, Vertical } from '@gravitate-js/excalibrr'
import { ColDef, ColGroupDef } from 'ag-grid-community'
import React from 'react'
import { AlignedRow } from '../types'

interface GridContainerProps {
  alignedRows: AlignedRow[]
  columnDefs: (ColDef | ColGroupDef)[]
  isLoading: boolean
  actionButtons: React.ReactNode
  columnGroupStyles: string
}

/**
 * Grid container component for the three-way mapping view
 */
export const GridContainer: React.FC<GridContainerProps> = ({
  alignedRows,
  columnDefs,
  isLoading,
  actionButtons,
  columnGroupStyles,
}) => {
  const visibleRowCount = alignedRows.length

  const resultsLabel = `${visibleRowCount.toLocaleString()} Results`

  return (
    <Vertical className='h-full' bg='layout'>
      <style>{columnGroupStyles}</style>
      <GraviGrid
        rowData={alignedRows}
        loading={isLoading}
        controlBarProps={{
          title: 'Three-Way Mapping View',
          subtitle: resultsLabel,
          actionButtons,
        }}
        agPropOverrides={{
          columnDefs,
          defaultColDef: {
            resizable: false,
            sortable: false,
            filter: false,
          },
          getRowId: (params) => params.data.id,
          rowHeight: 45,
          headerHeight: 40,
          groupHeaderHeight: 45,
          animateRows: false,
          suppressRowClickSelection: true,
          suppressCellFocus: true,
          suppressMovableColumns: true,
          suppressColumnVirtualisation: true,
          sideBar: null,
          suppressMenuHide: true,
          rowGroupPanelShow: 'never',
          pagination: false,
        }}
        height='100%'
      />
    </Vertical>
  )
}
